document.addEventListener("DOMContentLoaded", () => {
    const tabs = document.querySelectorAll(".ecustom-tabs__nav-item");
    const tabContents = document.querySelectorAll(".ecustom-tab-content");

    const descriptionTab = document.getElementById("description");
    const shippingInfoIndex = descriptionTab.innerText.indexOf("▼SHIPPING INFORMATION");

    tabs.forEach(tab => {
        tab.addEventListener("click", () => {
            const targetTab = tab.dataset.tab;

            tabs.forEach(tab => tab.classList.remove("active"));
            tabContents.forEach(content => content.classList.remove("active"));

            tab.classList.add("active");
            document.getElementById(targetTab).classList.add("active");
        });
    });

    if (shippingInfoIndex !== -1) {
        const shippingInfoText = descriptionTab.innerText.substring(0, shippingInfoIndex);
        descriptionTab.innerText = shippingInfoText;
    }
});